import { Component, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { getCompanyRequestsListDataTableStructure } from './utils/company-request-data-table-object';
import { DataTableAction, DataTableRowActions } from '@/components/data-table-builder/data-table.types';
import { CompanyRepository } from '@/store/company-state/company-state.repository';
import { CompanyService } from '../company/company.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Company } from '@/types';
import { Router } from '@angular/router';

@Component({
  selector: 'sm-company-request',
  imports: [PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './company-request.component.html',
  styleUrl: './company-request.component.scss',
})
export class CompanyRequestComponent implements OnInit {
  companyRepository = inject(CompanyRepository);
  companyService = inject(CompanyService);
  messageService = inject(MessageService);
  translate = inject(TranslateService);
  router = inject(Router);

  breadcrumb = [
    {
      label: 'settings.companyRequests.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.companyRequests.breadcrumb.requestsList',
      routerLink: ['/settings', 'requests-list'],
    },
  ];

  rowActionsFn: (target: Company) => DataTableRowActions = (target: Company) => {
    const additionalActions: Record<string, DataTableAction[] | undefined> = {};

    additionalActions['treat'] = [
      {
        icon: 'pi pi-check',
        label: 'settings.companyRequests.table.actions.treat',
        action: () => {
          this.router.navigate([`settings`, `requests-list`, `treat`, target.id]);
        },
      },
    ];
    return {
      additionalActions,
    };
  };

  data: Company[] = [];
  loading = false;

  dataTableObject = getCompanyRequestsListDataTableStructure({
    store: this.companyRepository,
    rowActionsFn: this.rowActionsFn,
  });

  ngOnInit() {
    this.companyService.getPendingRequests().subscribe({
      next: data => {
        this.data = data.content;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.translate.instant('settings.companyRequests.message.error.loading'),
        });
      },
    });
  }
}
